import React, { Component } from "react";
import { exchangeAddress, exchangeAbi } from "./Exchange.js";
import { freeTokenAddress, freeTokenAbi } from "../FreeToken.js";
import history from "./../history";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
const Web3 = require("web3");
let web3;
let FreeToken;
let Exchange;

class Demo extends Component {
  state = {
    manager: "",
    seller: "",
    contractAddress: "",
    tokenAddress: "",
    contractBalance: "",
    exchangeValue: "1",
    userAddress: "",
    approved: false,
    approvePending: false
  };

  async componentDidMount() {
    web3 = new Web3(window.web3.currentProvider);
    FreeToken = new web3.eth.Contract(freeTokenAbi, freeTokenAddress);
    Exchange = new web3.eth.Contract(exchangeAbi, exchangeAddress);
    const manager = await Exchange.methods.manager().call();
    const contractAddress = Exchange._address;
    const tokenAddress = await Exchange.methods.sourceAddress().call();
    const userAddress = localStorage.getItem("userAddress");
    let approved;
    const accounts = await web3.eth.getAccounts();

    let allowance = await FreeToken.methods
      .allowance(accounts[0], contractAddress)
      .call();
    if (!allowance) {
      approved = false;
    }
    allowance = web3.utils.fromWei(allowance, "ether");
    if (Number(allowance) > 100000) {
      approved = true;
    }

    this.setState({
      manager,
      contractAddress,
      tokenAddress,
      userAddress,
      approved
    });
  }

  onSubmit = async event => {
    console.log("this.state.exchangeValue =", this.state.exchangeValue);
    event.preventDefault();
    const accounts = await web3.eth.getAccounts();
    const weiAmount = web3.utils.toWei(this.state.exchangeValue, "ether");
    await Exchange.methods
      .exchange(weiAmount)
      .send({
        from: accounts[0]
      })
      // .on("receipt", receipt => {
      //   history.push(`${process.env.PUBLIC_URL}/Final`);
      // });
      .on("transactionHash", receipt => {
        history.push({
          pathname: `${process.env.PUBLIC_URL}/Final`,
          state: { txHashRecipt: receipt }
        });
      });
  };

  onApprove = async event => {
    event.preventDefault();
    const accounts = await web3.eth.getAccounts();
    await FreeToken.methods
      .approve(this.state.contractAddress, "-1")
      .send({
        from: accounts[0]
      })
      .on("transactionHash", receipt => {
        const approvePending = true;
        this.setState({
          approvePending
        });
      })
      .on("receipt", receipt => {
        const approved = true;
        const approvePending = false;
        this.setState({
          approved,
          approvePending
        });
      });
  };

  approveButton = () => {
    if (!this.state.approved) {
      return (
        <div className="col-md-4">
          <button
            type="button"
            className="primary-btn btn-block"
            onClick={this.onApprove}
            style={{ marginTop: "-10px" }}
          >
            Approve
          </button>
        </div>
      );
    }
  };

  swapButton = () => {
    if (this.state.approved) {
      return (
        <div className="col-md-4 not-first">
          <button
            type="button"
            className="primary-btn btn-block"
            onClick={this.onSubmit}
            disabled={
              !this.state.exchangeValue || Number(this.state.exchangeValue) <= 0
            }
          >
            Swap
          </button>
        </div>
      );
    }
  };

  render() {
    let approveRequest = "";
    if (!this.state.approved && !this.state.approvePending) {
      approveRequest = (
        <p className="approveSeparator">
          Please approve the DApp before proceeding.
        </p>
      );
    } else if (this.state.approvePending) {
      approveRequest = (
        <div>
          Please be patient and wait for the transaction to be confirmed
          <Loader type="ThreeDots" color="#1d1f7a" height={30} width={30} />
        </div>
      );
    } else {
      approveRequest = (
        <a href="#" className="link-style" onClick={this.onApprove}>
          Change approval
        </a>
      );
    }
    return (
      <div className="Start">
        <div className="lander">
          <form>
            <h1>Swap FRT for ETH</h1>
            <div className="row">
              <div className="col-md-8">
                <label htmlFor="fname" className="swapLabel">
                  Send
                </label>
                <br />
                <input
                  type="number"
                  className="swapInput"
                  placeholder="1 FRT"
                  style={{ marginBottom: "10px" }}
                  onChange={event =>
                    this.setState({ exchangeValue: event.target.value || "1" })
                  }
                />
              </div>
              <div className="col-md-8" style={{ marginBottom: "26px" }}>
                <br />
                <label htmlFor="lname" className="swapLabel">
                  Get
                </label>
                <br />
                <input
                  type="text"
                  className="swapInput"
                  value={`${Number(this.state.exchangeValue) / 10} ETH`}
                  readOnly
                />
              </div>
            </div>
            <div style={{ marginTop: "20px" }} className="row">
              {this.approveButton()}
              {this.swapButton()}
            </div>
            <br />
            {approveRequest}
          </form>
        </div>
      </div>
    );
  }
}

export default Demo;
